export default [
    {
        path: '/sales/sales-borrow-request',
        name: 'sales-borrow-request',
        props: true,
        component: () => import('@/views/sales/borrow-request/index.vue'),
        meta: {
            pageTitle: 'Borrow Request',
            breadcrumb: [
                {
                text: 'Borrow Request',
                active: true,
                },
            ],
        },
    },
    {
        path: '/sales/sales-borrow-request/:id',
        name: 'detail-sales-borrow-request',
        props: true,
        component: () => import('@/views/sales/borrow-request/detail.vue'),
        meta: {
            pageTitle: 'Detail Borrow Request',
            breadcrumb: [
                {
                text: 'Borrow Request',
                to: { name: 'sales-borrow-request' },
                },
                {
                text: 'Detail Borrow Request',
                active: true,
                },
            ],
        },
    },
]